import { getGMapsAddressString } from './GMapsUtils';

const appendAddressPart = (address, part) => {
  return part ? `${address}${address ? ', ' : ''}${part}` : address;
};
export const calculateAddress = (formData, addressType, view = false, isManualAddress) => {
  let address = '';
  if (addressType) {
    const horizontalAddress =
      formData[addressType.HORIZONTAL_ADDRESS.ID]?.label || '';
    const verticalAddress =
      formData[addressType.VERTICAL_ADDRESS.ID]?.label || '';
    const fullAddress = formData[addressType.ADDRESS.ID] || '';
    const streetNumber = formData[addressType.STREET_NUMBER.ID] || '';
    const floor = formData[addressType.FLOOR.ID] || '';
    const door = formData[addressType.DOOR.ID] || '';
    address = appendAddressPart(address, horizontalAddress);
    address = appendAddressPart(address, verticalAddress);
    if (view && !address) {
      address = fullAddress?.formattedAddress || address;
      address = appendAddressPart(address, streetNumber);
      address = appendAddressPart(address, floor);
      address = appendAddressPart(address, door);
    } else if (!address) {
        address = appendAddressPart(
          address,
          fullAddress && getGMapsAddressString(fullAddress?.value)
        );
        address = appendAddressPart(
          address,
          streetNumber ? `Número: ${streetNumber}` : ''
        );
        address = appendAddressPart(address, floor ? `Planta: ${floor}` : '');
        address = appendAddressPart(address, door ? `Puerta: ${door}` : '');
    }
  }
  if(isManualAddress){
    const horizontal =
      formData[addressType.HORIZONTAL_ADDRESS.ID]?.label ||  formData[addressType.HORIZONTAL_ADDRESS.ID];
    address = `Direccion no encontrada: ${horizontal}`
  }
  return address;
};
